// extracted by mini-css-extract-plugin
export default {"item":"CartItem_item__kSeN+","title":"CartItem_title__GvhbE","content":"CartItem_content__Nn18Y","price":"CartItem_price__ptbx-","remove":"CartItem_remove__RfRv1"};